import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-book-credit-note-report-monthwise',
  // standalone: true,
  // imports: [],
  templateUrl: './book-credit-note-report-monthwise.component.html',
  styleUrl: './book-credit-note-report-monthwise.component.scss'
})
export class BookCreditNoteReportMonthwiseComponent {
  CreditNoteData: any[] = [];
  startDate: string = '';
  endDate: string = '';
  currentDate = new Date();

  reportType = 'Monthwise';
  officerepwise: any;
  repName: any;
  loading = false;

  // Table-related
  monthList: string[] = [];
  monthwiseData: any[] = [];
  monthTotals: any = {};
  overallTotal: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<BookCreditNoteReportMonthwiseComponent>,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    debugger
    console.log('Dialog Data:', this.data);

    this.startDate = this.data?.start_date || this.data?.startDate || '';
    this.endDate = this.data?.end_date || this.data?.endDate || '';
    this.officerepwise = this.data?.office_rep_name || this.data?.officerepwise || '';

    if (!this.startDate || !this.endDate) {
      console.warn('⚠ Missing start_date or end_date');
      return;
    }

    this.getCreditNoteData();
  }

  // ------------------------------------------------
  //      CALL CREDIT NOTE API
  // ------------------------------------------------
  getCreditNoteData(): void {
    this.loading = true;

    const payload = {
      start_date: this.startDate,
      end_date: this.endDate,
      office_rep_name: this.officerepwise,
    };

    this.service.getBookCreditNoteMonthwise(payload).subscribe({
      next: (res: any) => {
        console.log('✅ Credit Note API Response:', res);
        this.CreditNoteData = res || [];
        this.prepareMonthwiseData();
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ Error:', err);
        this.loading = false;
      },
    });
  }

  // ------------------------------------------------
  //        PROCESS DATA FOR TABLE
  // ------------------------------------------------
 prepareMonthwiseData() {
    const repMap: any = {};
    const allMonthsSet = new Set<string>();

    // Define month order
    const monthOrder = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    for (let office of this.CreditNoteData) {
        const repName = office.office_rep_name || 'Unknown';

        if (!repMap[repName]) repMap[repName] = { office_rep_name: repName };

        for (let yearData of office.yearly_data || []) {
            for (let m of yearData.months || []) {
                const month = m.month;
                const amount = parseFloat(m.creditnote_total) || 0;

                allMonthsSet.add(month);

                repMap[repName][month] = (repMap[repName][month] || 0) + amount;
            }
        }

        // Total per rep
        repMap[repName]['Total'] = office.total_creditnote || 0;
    }

    // Sort months according to monthOrder
    this.monthList = Array.from(allMonthsSet).sort((a, b) => {
        return monthOrder.indexOf(a) - monthOrder.indexOf(b);
    });

    this.monthwiseData = Object.values(repMap);

    this.calculateMonthwiseTotals();
}

  // ------------------------------------------------
  //      CALCULATE MONTH TOTALS
  // ------------------------------------------------
  calculateMonthwiseTotals() {
    this.monthTotals = {};
    this.overallTotal = 0;

    for (let month of this.monthList) {
      let total = 0;
      for (let row of this.monthwiseData) {
        total += row[month] || 0;
      }
      this.monthTotals[month] = total;
      this.overallTotal += total;
    }
  }

  // ------------------------------------------------
  //      ROW TOTAL
  // ------------------------------------------------
  getRowTotal(row: any): number {
    let total = 0;
    for (let m of this.monthList) {
      total += row[m] || 0;
    }
    return total;
  }

  // ------------------------------------------------
  //      PRINT REPORT
  // ------------------------------------------------
  printPage4() {
  const printContent = document.getElementById('print-section');
  const WindowPrt = window.open('', '', 'width=1400,height=900');

  WindowPrt.document.write(`
    <html>
      <head>
        <title>Book Payment Monthwise Report</title>
        <style>

          /* ========== FORCE COLORS IN PRINT ========== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          @page {
            size: A3 landscape;
            margin: 5mm;
            margin-left: 20mm;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 15px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
          }

          th, td {
            border: 1px solid black;
            padding: 6px;
            text-align: right;
          }

          /* Header color */
          thead th {
            background-color: #dfe6e9 !important;
            text-align: center;
            font-size: 17px;
          }

          /* Footer Total Row */
          tfoot tr {
           background-color: #c8753f !important;
            font-weight: bold;
          }

          .noPrint {
            display: none !important;
          }

        </style>
      </head>
      <body>${printContent?.innerHTML}</body>
    </html>
  `);

  WindowPrt.document.close();
  setTimeout(() => {
    WindowPrt.print();
    WindowPrt.close();
  }, 700);
}
exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

}
